import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from './AppIcon';
import Button from './ui/Button';

const LoginRequiredBuffer = ({ returnTo = '/help-support' }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogin = () => {
    navigate('/login-register', { 
      state: { from: location.pathname } 
    });
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-lg shadow-lg p-8 text-center">
          {/* Icon */}
          <div className="mb-6 flex justify-center">
            <div className="bg-purple-100 rounded-full p-4">
              <Icon name="Lock" size={40} className="text-purple-600" />
            </div>
          </div>

          {/* Heading */}
          <h1 className="text-2xl font-bold text-gray-900 mb-3">
            Login Required
          </h1>

          {/* Message */}
          <p className="text-gray-600 mb-8 leading-relaxed">
            You need to be logged in to access this page. Sign in with your account to view our help center and support resources.
          </p>

          {/* Login Button */}
          <Button
            onClick={handleLogin}
            variant="primary"
            className="w-full mb-4"
          >
            <Icon name="LogIn" size={18} className="inline mr-2" />
            Go to Login
          </Button>

          {/* Back Link */}
          <button
            onClick={() => navigate('/')}
            className="text-purple-600 hover:text-purple-700 font-medium transition-colors"
          >
            Back to Home
          </button>

          {/* Additional Info */}
          <div className="mt-8 pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-600 mb-3">
              Don't have an account?
            </p>
            <Button
              onClick={handleLogin}
              variant="outline"
              className="w-full"
            >
              Create Account
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginRequiredBuffer;
